import { render, staticRenderFns } from "./InvestmentApprovals.vue?vue&type=template&id=0db9f08f"
import script from "./InvestmentApprovals.vue?vue&type=script&lang=js"
export * from "./InvestmentApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports